// extracted by mini-css-extract-plugin
export default {"modalContain":"src-pages-Order-Components-OrderCancelModal-css-module__modalContain--0Ji20"};